import { useQuery } from '@tanstack/react-query';

import type { DomainListPopupsResponse, PopupsListParams } from '@/Swagger';
import axiosInstance from '@/axios/axios';
import type { ExtractQueryFunction, UseAxiosQueryOptions } from '@/utils/typeHelper';

import { 팝업_쿼리_키 } from './query-keys';

type QueryOptions = UseAxiosQueryOptions<DomainListPopupsResponse, ReturnType<typeof 팝업_쿼리_키.list>>;

const queryFn: ExtractQueryFunction<QueryOptions> = ({ queryKey }) => {
  const [, query] = queryKey;

  return axiosInstance
    .get<DomainListPopupsResponse>('/shops/popups', {
      params: query,
    })
    .then(v => v.data);
};
/**
 * 팝업 목록을 조회하는 API
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Shops/get_shops_popups
 */
export function useQueryPopups(query?: PopupsListParams, option?: QueryOptions) {
  return useQuery({ queryKey: 팝업_쿼리_키.list(query), queryFn: queryFn, ...option });
}
